export default {
  setDraftPosts(state, draftPosts) {
    state.draftPosts = draftPosts;
  },
  deleteDraftPost(state, id) {
    state.draftPosts = state.draftPosts.filter(item => item.id !== id);
  },
  addDataDraft(state, post) {
    state.draftDataPost = post;
  },
  // clearUnreadPosts(state) {
  //   console.log('Clearing unread posts collection');
  //   state.unreadPosts = [];
  // },
};
